import MockUtils from "./mock.utils";
import { Notification } from "../../../modules/Notification";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
const adapter = new LocalStorage("db");
const db = low(adapter);

let remarkTableMock;
export default function mockReceiptCustomFields(mock) {
  //Status Message
  function StatusMessage(res) {
    var status = res.status;
    var statusText = res.Message;
    if (status === 200) {
      Notification("success", "success");
      return true;
    } else if (status === 400) {
      Notification("error", "Error Occured");
      return false;
    }
  }
  //Get All Receipts Items
  async function GetReceiptCustomFields(id) {
    return await fetch(window.$apiurl + "/receipts/customfields/" + id, {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization: `bearer ${db.read().getState().Token}`,
        "X-FP-API-KEY": "iphone", //it can be iPhone or your any other attribute
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        const statusCode = response.status;
        const data = await response.json();
        console.log(data);
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        return ChangeId(res[1]);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  //Post Trans Billing Shipping
  async function PostReceiptCustomField(id, someData) {
    return fetch(window.$apiurl + "/receipts/customfield/" + id, {
      method: "post",
      withCredentials: true,
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: `bearer ${db.read().getState().Token}`,
        "X-FP-API-KEY": "iphone", //it can be iPhone or your any other attribute
        "Content-Type": "application/json",
      },
      body: JSON.stringify(someData),
    })
      .then(async (response) => {
        const statusCode = response.status;
        const data = await response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        return res[1];
      })
      .catch((error) => {
        //console.error(error);
      });
  }
  //Delete Receipt Item
  async function DeleteReceiptCustomField(id) {
    return await fetch(window.$apiurl + "/receipts/customfield/" + id, {
      method: "delete",
      withCredentials: true,
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: `bearer ${db.read().getState().Token}`,
        "X-FP-API-KEY": "iphone", //it can be iPhone or your any other attribute
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        return response;
      })
      .then((res) => {
        return StatusMessage(res);
      })
      .catch((err) => {
        return StatusMessage(err);
      });
  }

  async function GetReceiptCustomField(ReceiptId) {
    return await fetch(window.$apiurl + "/Receipts/CustomField/" + ReceiptId, {
      method: "get",
      withCredentials: true,
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: `bearer ${db.read().getState().Token}`,
        "X-FP-API-KEY": "iphone", //it can be iPhone or your any other attribute
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        return res;
      })
      .catch((err) => {
        Notification("error", "err");
        return false;
      });
  }
  async function PutReceiptCustomField(someData, itemId) {
    return fetch(window.$apiurl + "/Receipts/CustomField/" + itemId, {
      method: "put",
      withCredentials: true,
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: `bearer ${db.read().getState().Token}`,
        "X-FP-API-KEY": "iphone", //it can be iPhone or your any other attribute
        "Content-Type": "application/json",
      },
      body: JSON.stringify(someData),
    })
      .then(async (response) => {
        return response;
      })
      .then((res) => {
        return StatusMessage(res);
      })
      .catch((err) => {
        return StatusMessage(err);
      });
  }
  //----------------------------------Mock--------------------------------------
  mock.onPost("api/ReceiptCustomFields").reply(async ({ data }) => {
    const { remark } = JSON.parse(data);
    const { Name = "", Value = "" } = remark;
    const id = generateRemarkId();
    const newcustomField = {
      id,
      Name,
      Value,
    };
    var postCustomField = await PostReceiptCustomField(
      remark.ReceiptId,
      newcustomField
    );
    //Manage Data Result
    if (postCustomField.Id != undefined) {
      Notification("success", "Custom Receipt has been added successfully");
      postCustomField.id = postCustomField.Id;
      remarkTableMock.push(newcustomField);
      return [
        200,
        {
          remark: newcustomField,
          message: postCustomField.Message,
          success: true,
        },
      ];
    } else {
      if (postCustomField.Message) {
        Notification("error", postCustomField.Message);
        return [400, { message: postCustomField.Message, success: false }];
      } else {
        Notification("error", "Error occured");
        return [400, { message: postCustomField.Message, success: false }];
      }
    }
  });

  //mock on Post
  mock.onPost(/api\/ReceiptCustomFieldsfind\/\d+/).reply(async (config) => {
    const mockUtils = new MockUtils();
    const urls = config.url.split("/");
    const id = urls[2];
    const { queryParams } = JSON.parse(config.data);
    remarkTableMock = await GetReceiptCustomFields(id);
    delete queryParams.filter.ReLoadTableCustomId;
    const filterdRemarks = mockUtils.baseFilter(remarkTableMock, queryParams);
    return [200, filterdRemarks];
  });

  mock.onPost("api/ReceiptCustomFields/deleteReceipts").reply((config) => {
    const { ids } = JSON.parse(config.data);
    ids.forEach((id) => {
      const index = remarkTableMock.findIndex((el) => el.id === id);
      if (index > -1) {
        remarkTableMock.splice(index, 1);
      }
    });
    return [200];
  });

  mock.onGet(/api\/ReceiptCustomFields\/\d+/).reply(async (config) => {
    const id = config.url.match(/api\/ReceiptCustomFields\/(\d+)/)[1];
    const remark = remarkTableMock.find((el) => el.id === +id);
    if (!remark) {
      return [400];
    }

    return [200, remark];
  });

  mock.onPut(/api\/ReceiptCustomFields\/\d+/).reply(async (config) => {
    const id = config.url.match(/api\/ReceiptCustomFields\/(\d+)/)[1];
    const { remark } = JSON.parse(config.data);
    var postOrder = await PutReceiptCustomField(remark, id);
    const index = remarkTableMock.findIndex((el) => el.id === +id);
    if (!index) {
      return [400];
    }
    remarkTableMock[index] = { ...remark };
    return [200];
  });

  mock.onDelete(/api\/ReceiptCustomFields\/\d+/).reply(async (config) => {
    const id = config.url.match(/api\/ReceiptCustomFields\/(\d+)/)[1];
    const index = remarkTableMock.findIndex((el) => el.id === +id);
    var deleteObj = await DeleteReceiptCustomField(id);
    if (!deleteObj) {
      return [400];
    }
    remarkTableMock.splice(index, 1);
    return [200];
  });
}

function generateRemarkId() {
  const ids = remarkTableMock.map((el) => el.id);
  const maxId = Math.max(...ids);
  return maxId + 1;
}

function ChangeId(list) {
  for (var item in list) {
    list[item].id = list[item].Id;
    delete list[item].Id;
  }
  return list;
}
